import { useEffect } from 'react';

// Swaps the browser tab icon to the current band's own logo, straight from
// Branding & Settings - so each band's dashboard/audience/public pages show
// their own icon rather than a generic one.
export default function useFavicon(url) {
  useEffect(() => {
    if (!url) return;
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = url;
  }, [url]);
}
